module.exports = __webpack_public_path__ + "img/weixin.53782829.jpg";